import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import dayjs from 'dayjs'

Vue.use(ElementUI, { size: 'medium' })

// 全局过滤器
Vue.filter('yuan', val => '¥' + (val / 100).toFixed(2))
Vue.filter('time', val => val ? dayjs(val).format('YYYY-MM-DD HH:mm') : '-')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')